module.exports = __webpack_public_path__ + "static/Sello-nueva-aqui-5960de606cbd70ba41a8f660ca495c79.png";